export default "/images/vendor/flag-icon-css/flags/1x1/gb.svg?ad3aa4f8661cd353439d28fecaefc345";